import { useState, useRef, useEffect, useMemo } from "react";
import FilterIcon from "../../assets/icons/instant_mix.svg";
import StatusExitIcon from "../../assets/icons/status_exit.svg";
import StatusEnterIcon from "../../assets/icons/login.svg";
import SickIcon from "../../assets/icons/leave_icons/sick_leave.svg";
import CasualIcon from "../../assets/icons/leave_icons/casual.svg";
import PrivilegeIcon from "../../assets/icons/leave_icons/privilage_leave.svg";
import MaternityIcon from "../../assets/icons/leave_icons/maternity.svg";
import MenstrualIcon from "../../assets/icons/leave_icons/menstrual.svg";
import InitialsCircle from "../InitialsCircle";
import DownloadIcon from "../../assets/icons/download.svg";
import TaskNotFoundImage from "../../assets/images/task-not-found-1 6.png";
import moment from "moment";
import "./ManagerTeamView.css";
import { TeamManagerLoader } from "../../utils/skeleton";

const ManagerTeamView = ({
  filteredTeamDataResponse,
  getAllReporteesResponse,
  managerTeamList,
  lastTeamElementRef,
  teamDetailManagerDataResponseStatus,
  filters,
  setFilters,
  downloadReport,
}) => {
  const leaveTypesMap = [
    { leave_type: "Maternity", description: "Maternity Leave" },
    { leave_type: "Paternity", description: "Paternity Leave" },
    { leave_type: "Miscarriage", description: "Miscarriage Leave" },
    { leave_type: "SL", description: "Sick leave" },
    { leave_type: "PL", description: "Privilege leave" },
    { leave_type: "RPL", description: "Reserved PL" },
    { leave_type: "CL", description: "Casual leave" },
    { leave_type: "Menstrual", description: "Menstrual leave" },
    { leave_type: "ESIC", description: "ESIC" },
  ];

  const getLeaveIcon = (type) => {
    switch (type) {
      case "Sick Leave":
      case "SL":
        return SickIcon;
      case "Casual Leave":
      case "CL":
        return CasualIcon;
      case "Privilege Leave":
      case "PL":
        return PrivilegeIcon;
      case "Maternity":
      case "Maternity Leave":
        return MaternityIcon;
      case "Menstrual":
      case "Menstrual Leave":
        return MenstrualIcon;
      default:
        return CasualIcon;
    }
  };

  const today = new Date();
  const statusData = ["all", "logged in", "logged out", "leave"];

  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedEndDate, setSelectedEndDate] = useState(today);
  const [selectingStart, setSelectingStart] = useState(true);
  const [currentMonth, setCurrentMonth] = useState(
    new Date(today.getFullYear(), today.getMonth(), 1),
  );
  const [showCalendar, setShowCalendar] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [showDesignationDropdown, setShowDesignationDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const [employeeView, setEmployeeView] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("Status");
  const [selectedDesignation, setSelectedDesignation] = useState("Designation");
  const [selectedLocation, setSelectedLocation] = useState("Location");
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [mevExpandedRows, setMevExpandedRows] = useState(new Set());
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const calendarRef = useRef();
  const dropdownRef = useRef();
  const statusDropdownRef = useRef();
  const designationDropdownRef = useRef();
  const employeeViewRequestedRef = useRef(false);
  const locationDropdownRef = useRef();
  const mobileFilterRef = useRef();
  const mobileBtnRef = useRef();

  useEffect(() => {
    const close = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
        setSelectingStart(true);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setShowDropdown(false);
      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(e.target)
      )
        setShowStatusDropdown(false);
      if (
        designationDropdownRef.current &&
        !designationDropdownRef.current.contains(e.target)
      )
        setShowDesignationDropdown(false);
      if (
        locationDropdownRef.current &&
        !locationDropdownRef.current.contains(e.target)
      )
        setShowLocationDropdown(false);
      if (
        mobileFilterRef.current &&
        !mobileFilterRef.current.contains(e.target) &&
        mobileBtnRef.current &&
        !mobileBtnRef.current.contains(e.target)
      )
        setShowMobileFilters(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (
      employeeViewRequestedRef.current &&
      teamDetailManagerDataResponseStatus === "SUCCESS"
    ) {
      setEmployeeView(true);
      employeeViewRequestedRef.current = false;
    }
  }, [teamDetailManagerDataResponseStatus]);

  const formatTime = (timeStr, statusObj) => {
    if (timeStr !== null && timeStr !== undefined) {
      let [hours, minutes] = timeStr.split(":");
      hours = parseInt(hours);

      const suffix = hours >= 12 ? "PM" : "AM";

      const adjustedHours = hours % 12 || 12;

      return `${adjustedHours}:${minutes} ${suffix}`;
    } else {

      if (typeof statusObj === "object" && statusObj !== null) {
        if (statusObj.leave_type) return "Leave";
        if (statusObj.att_status) {
          const s = statusObj.att_status;
          return s.charAt(0).toUpperCase() + s.slice(1).replace("_", " ");
        }
        return "";
      }
      return statusObj || "";
    }
  };

  const monthDays = useMemo(() => {
    const start = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      1,
    );

    const end = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      0,
    );

    const days = [];

    const startDay = (start.getDay() + 6) % 7;

    const prevMonthEnd = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      0,
    ).getDate();

    for (let i = startDay - 1; i >= 0; i--) {
      days.push({
        day: prevMonthEnd - i,
        type: "prev",
      });
    }

    for (let i = 1; i <= end.getDate(); i++) {
      days.push({ day: i, type: "current" });
    }

    const remaining = 42 - days.length;
    for (let i = 1; i <= remaining; i++) {
      days.push({ day: i, type: "next" });
    }

    return days;
  }, [currentMonth]);

  const changeMonth = (dir) => {
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() + dir, 1),
    );
  };

  const selectDate = (dayObj) => {
    if (dayObj.type !== "current") return;

    const newDate = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      dayObj.day,
    );

    const formatString = (date) => {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yy = String(date.getFullYear()).slice(-2);
      return `${dd}-${mm}-${yy}`;
    };

    if (selectingStart) {

      setSelectedDate(newDate);
      setSelectedEndDate(newDate);
      setSelectingStart(false);
    } else {

      let startDate = selectedDate;
      let endDate = newDate;

      if (endDate < startDate) {
        [startDate, endDate] = [endDate, startDate];
        setSelectedDate(startDate);
      }
      setSelectedEndDate(endDate);
      setSelectingStart(true);
      setShowCalendar(false);

      if (setFilters) {
        setFilters((prev) => ({
          ...prev,
          start_date: formatString(startDate),
          end_date: formatString(endDate),
        }));
      }
    }
  };

  const displayReportees = useMemo(() => {
    const allReportees = getAllReporteesResponse?.reportees || [];
    if (allReportees.length === 0) return [];

    let selectedReportee = null;
    let others = [];

    if (search) {
      selectedReportee = allReportees.find((r) => r.full_name === search);
    }

    if (selectedReportee) {
      others = allReportees
        .filter((r) => r.employee_id !== selectedReportee.employee_id)
        .slice(0, 2);
      return [selectedReportee, ...others];
    } else {
      return allReportees.slice(0, 3);
    }
  }, [getAllReporteesResponse?.reportees, search]);

  const getStatus = (member) => {

    if (typeof member.status === "object" && member.status !== null) {
      return member.status;
    }

    return {
      att_status: member.status,
      holiday: "",
      leave_type: "",
      compoff: "",
    };
  };

  const renderStatus = (member) => {
    const statusObj = getStatus(member);
    const attStatus = statusObj.att_status;
    const holiday = statusObj.holiday;
    const leaveType = statusObj.leave_type;
    const compoff = statusObj.compoff;

    const getAttStatusBadgeClass = (status) => {
      if (status === "present" || status === "logged_out") return "present";
      if (status === "absent") return "absent";
      return "absent";
    };

    if (holiday) {
      return <span className="mn-badge holiday">{holiday.toUpperCase()}</span>;
    }

    if (leaveType) {
      const leaveInfo = leaveTypesMap.find((lt) => lt.leave_type === leaveType);
      const leaveLabel = leaveInfo
        ? leaveInfo.description.toUpperCase()
        : leaveType.toUpperCase();
      const leaveIcon = getLeaveIcon(leaveType);
      return (
        <span className="mn-badge leave">
          <img src={leaveIcon} alt="" className="mn-badge-icon" />
          {leaveLabel}
        </span>
      );
    }

    if (compoff) {
      return (
        <div className="mn-badge-row">
          <span className="mn-badge compoff">COMP OFF</span>
          {attStatus && (
            <span className={`mn-badge ${getAttStatusBadgeClass(attStatus)}`}>
              {attStatus.toUpperCase().replace("_", " ")}
            </span>
          )}
        </div>
      );
    }

    if (attStatus === "present")
      return <span className="mn-badge present">PRESENT</span>;
    if (attStatus === "absent")
      return <span className="mn-badge absent">ABSENT</span>;
    if (attStatus === "logged_out")
      return <span className="mn-badge present">LOGGED OUT</span>;
    if (attStatus) {
      return (
        <span className="mn-badge absent">
          {attStatus.toUpperCase().replace("_", " ")}
        </span>
      );
    }
  };

  useEffect(() => {
    if (filters && !filters.search_term) setSearch("");
    if (filters && !filters.designation) setSelectedDesignation("Designation");
    if (filters && !filters.status && selectedStatus !== "All")
      setSelectedStatus("Status");
    if (filters && !filters.store) setSelectedLocation("Location");

    if (selectingStart) {
      if (filters && filters.start_date) {
        const [dd, mm, yy] = filters.start_date.split("-");
        if (dd && mm && yy) {
          const yyyy = yy.length === 2 ? `20${yy}` : yy;
          const parsedDate = new Date(
            parseInt(yyyy, 10),
            parseInt(mm, 10) - 1,
            parseInt(dd, 10),
          );

          if (parsedDate.toDateString() !== selectedDate.toDateString()) {
            setSelectedDate(parsedDate);
            setCurrentMonth(
              new Date(parsedDate.getFullYear(), parsedDate.getMonth(), 1),
            );
          }
        }
      }

      if (filters && filters.end_date) {
        const [dd, mm, yy] = filters.end_date.split("-");
        if (dd && mm && yy) {
          const yyyy = yy.length === 2 ? `20${yy}` : yy;
          const parsedEndDate = new Date(
            parseInt(yyyy, 10),
            parseInt(mm, 10) - 1,
            parseInt(dd, 10),
          );

          if (parsedEndDate.toDateString() !== selectedEndDate.toDateString()) {
            setSelectedEndDate(parsedEndDate);
          }
        }
      }

      if (
        filters &&
        !filters.search_term &&
        !filters.designation &&
        !filters.status &&
        !filters.store &&
        filters.start_date === filters.end_date
      ) {
        setShowCalendar(false);
        setShowDesignationDropdown(false);
        setShowStatusDropdown(false);
        setShowLocationDropdown(false);
        setShowDropdown(false);
      }
    }
  }, [filters, selectedDate]);

  return (
    <div className="manager-wrapper">
      <div className="mn-header-text">team</div>

      <div className="mn-filters">
        <img className="mn-filter-ico" src={FilterIcon} alt="" />
                <div className="mn-filter-box mn-filter-date-box" ref={calendarRef}>
          <button
            className={`mn-filter-btn ${showCalendar ? "active" : ""}`}
            onClick={() => setShowCalendar(!showCalendar)}
          >
            {(() => {
              const fmt = (dt) =>
                `${dt.getDate()} ${dt.toLocaleString("default", { month: "short" })}'${String(dt.getFullYear()).slice(-2)}`;
              if (
                selectedDate.toDateString() === selectedEndDate.toDateString()
              )
                return fmt(selectedDate);
              return `${fmt(selectedDate)} – ${fmt(selectedEndDate)}`;
            })()}
            <span>▾</span>
          </button>

          {showCalendar && (
            <div className="mn-calendar-popup">
              <div className="mn-calendar-header">
                <span>
                  {currentMonth.toLocaleString("default", {
                    month: "long",
                  })}{" "}
                  {currentMonth.getFullYear()}
                </span>
                <div className="flex items-center">
                  <div className="mn-cal-nav" onClick={() => changeMonth(-1)}>
                    ‹
                  </div>
                  <div className="mn-cal-nav" onClick={() => changeMonth(1)}>
                    ›
                  </div>
                </div>
              </div>

              <div className="mn-cal-head">
                {["M", "T", "W", "T", "F", "S", "S"].map((d, i) => (
                  <div key={i} className="day-name">
                    {d}
                  </div>
                ))}
              </div>
              <div className="mn-calendar-grid">
                {monthDays.map((d, i) => {
                  const cellDate = new Date(
                    currentMonth.getFullYear(),
                    currentMonth.getMonth(),
                    d.day,
                  );

                  const isFuture = d.type === "current" && cellDate > today;
                  const isDisabled = d.type !== "current" || isFuture;

                  const cellTime =
                    d.type === "current"
                      ? new Date(
                          cellDate.getFullYear(),
                          cellDate.getMonth(),
                          cellDate.getDate(),
                        ).getTime()
                      : null;
                  const startTime = new Date(
                    selectedDate.getFullYear(),
                    selectedDate.getMonth(),
                    selectedDate.getDate(),
                  ).getTime();
                  const endTime = new Date(
                    selectedEndDate.getFullYear(),
                    selectedEndDate.getMonth(),
                    selectedEndDate.getDate(),
                  ).getTime();
                  const todayTime = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate(),
                  ).getTime();

                  const isToday = cellTime === todayTime;
                  const isRangeStart = cellTime === startTime;
                  const isRangeEnd = cellTime === endTime;
                  const isInRange =
                    cellTime !== null &&
                    cellTime > startTime &&
                    cellTime < endTime;
                  const isSingleDay =
                    startTime === endTime && cellTime === startTime;

                  const colIndex = i % 7;
                  const isRowStart = colIndex === 0;
                  const isRowEnd = colIndex === 6;

                  return (
                    <div
                      key={i}
                      className={`day 
                                                ${isDisabled ? "disabled" : ""} 
                                                ${isToday ? "today" : ""}
                                                ${isSingleDay && !isToday ? "selected" : ""}
                                                ${!isSingleDay && isRangeStart ? "range-start" : ""}
                                                ${!isSingleDay && isRangeEnd ? "range-end" : ""}
                                                ${isInRange ? "in-range" : ""}
                                                ${(isInRange || isRangeStart || isRangeEnd) && isRowStart ? "row-start" : ""}
                                                ${(isInRange || isRangeStart || isRangeEnd) && isRowEnd ? "row-end" : ""}`}
                      onClick={() => {
                        if (!isDisabled) selectDate(d);
                      }}
                    >
                      {d.day}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div
          ref={mobileFilterRef}
          className={`mn-advanced-filters${showMobileFilters ? " mn-show" : ""}`}
        >
        <div className="mn-filter-designation" ref={designationDropdownRef}>
          <div
            className={`mn-filter-btn ${selectedDesignation !== "Designation" ? "mn-active" : ""} ${employeeView ? "mev-disabled-filter" : ""}`}
            style={{
              cursor: employeeView ? "not-allowed" : "pointer",
              opacity: employeeView ? 0.6 : 1,
            }}
            onClick={() =>
              !employeeView &&
              setShowDesignationDropdown(!showDesignationDropdown)
            }
          >
            {selectedDesignation} ▾
          </div>
          {showDesignationDropdown && (
            <div className="mn-dropdown-popup">
              {filteredTeamDataResponse?.designation?.map((desc, index) => (
                <div
                  key={index}
                  className="mn-dropdown-item"
                  onClick={() => {
                    setSelectedDesignation(desc);
                    setShowDesignationDropdown(false);
                    if (setFilters)
                      setFilters((prev) => ({
                        ...prev,
                        designation:
                          desc === "Designation" || desc === "All" ? "" : desc,
                      }));
                  }}
                >
                  <div className="mn-avatar-text">{desc}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="mn-filter-box" ref={statusDropdownRef}>
          <button
            className={`mn-filter-btn ${showStatusDropdown ? "active" : ""}`}
            onClick={() => setShowStatusDropdown(!showStatusDropdown)}
          >
            {selectedStatus} ▾
          </button>
          {showStatusDropdown && (
            <div className="mn-dropdown-popup">
              {statusData.map((status, index) => (
                <div
                  key={index}
                  className="mn-dropdown-item"
                  onClick={() => {
                    const statusVal =
                      status.charAt(0).toUpperCase() + status.slice(1);
                    setSelectedStatus(statusVal);
                    setShowStatusDropdown(false);
                    let statusPayload = status.toLowerCase().replace(" ", "_");
                    if (setFilters)
                      setFilters((prev) => ({
                        ...prev,
                        status: statusPayload,
                      }));
                  }}
                >
                  <div className="mn-avatar-text">
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="mn-filter-location" ref={locationDropdownRef}>
          <div
            className={`mn-filter-btn ${selectedLocation !== "Location" ? "mn-active" : ""} ${employeeView ? "mev-disabled-filter" : ""}`}
            style={{
              cursor: employeeView ? "not-allowed" : "pointer",
              opacity: employeeView ? 0.6 : 1,
            }}
            onClick={() =>
              !employeeView && setShowLocationDropdown(!showLocationDropdown)
            }
          >
            {selectedLocation} ▾
          </div>
          {showLocationDropdown && (
            <div className="mn-dropdown-popup mn-location-popup">
              {filteredTeamDataResponse?.store?.map((loc, index) => (
                <div
                  key={index}
                  className="mn-dropdown-item"
                  onClick={() => {
                    setSelectedLocation(loc || "Location");
                    setShowLocationDropdown(false);
                    if (setFilters)
                      setFilters((prev) => ({
                        ...prev,
                        store: loc != null ? loc.toString() : "",
                      }));
                  }}
                >
                  <div className="mn-avatar-text">{loc}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        </div>

        <div className="mn-filter-users" ref={dropdownRef}>
          <div
            className="mn-avatar-group"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {displayReportees.map((reportee, idx) => {
              const isSelected =
                search && reportee.full_name === search && idx === 0;
              return (
                <div
                  key={reportee.employee_id || idx}
                  className="mn-avatar"
                  style={{
                    border: isSelected ? "2px solid #253037" : "none",
                    borderRadius: "12px",
                    height: "36px",
                    width: "36px",
                  }}
                >
                  <InitialsCircle
                    fullName={reportee.full_name}
                    size={!isSelected ? 36 : 34}
                    borderRadius="12px"
                  />
                </div>
              );
            })}
            {displayReportees.length === 0 && (
              <>
                <div className="mn-avatar" />
                <div className="mn-avatar" />
                <div className="mn-avatar" />
              </>
            )}
            <div
              className="mn-avatar-arrow-wrap"
              style={{
                right:
                  displayReportees.length === 1
                    ? "-88px"
                    : displayReportees.length === 2
                      ? "-120px"
                      : "-147px",
              }}
            >
              <span className="mn-avatar-arrow">▾</span>
            </div>
          </div>

          {showDropdown && (
            <div className="mn-dropdown-popup">
              <div style={{ position: "relative", width: "100%" }}>
                <input
                  className="mn-search-input"
                  style={{
                    width: "100%",
                    paddingRight: "30px",
                    boxSizing: "border-box",
                  }}
                  placeholder="Search reportees"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    if (!e.target.value) {
                      setEmployeeView(false);
                      setSelectedEmployee(null);
                      if (setFilters)
                        setFilters((prev) => ({ ...prev, search_term: "" }));
                      setShowDropdown(false);
                    }
                  }}
                />
                {search && (
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#999",
                      lineHeight: 1,
                    }}
                    onClick={() => {
                      setSearch("");
                      setEmployeeView(false);
                      setSelectedEmployee(null);
                      if (setFilters)
                        setFilters((prev) => ({ ...prev, search_term: "" }));
                      setShowDropdown(false);
                    }}
                  >
                    ✕
                  </span>
                )}
              </div>
              <div className="drop-users">
                {(getAllReporteesResponse?.reportees || []).map((m, i) => {
                  const isSelected =
                    selectedEmployee?.employee_id === m.employee_id;
                  return (
                    <div
                      key={i}
                      className="mn-dropdown-item"
                      style={{
                        cursor: "pointer",
                        backgroundColor: isSelected ? "#FFF8E1" : "transparent",
                      }}
                      onClick={() => {
                        setSearch(m.full_name);
                        setSelectedEmployee(m);
                        employeeViewRequestedRef.current = true;
                        if (setFilters)
                          setFilters((prev) => ({
                            ...prev,
                            search_term: m.employee_id,
                          }));
                        setShowDropdown(false);
                      }}
                    >
                      <div className="mn-small-avatar" />
                      <div className="mn-avatar-text">{m.full_name}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

                <button
          ref={mobileBtnRef}
          className="mn-mobile-filter-btn"
          onClick={() => setShowMobileFilters((v) => !v)}
        >
          <img src={FilterIcon} alt="Filters" />
        </button>

        <div className="mn-download-btn" onClick={downloadReport}>
          <img src={DownloadIcon} alt="Download Report" />
          Download Report
        </div>
      </div>
      {teamDetailManagerDataResponseStatus === "PENDING" && (
        <TeamManagerLoader />
      )}
      {teamDetailManagerDataResponseStatus === "SUCCESS" && (
        <>
          {employeeView ? (
            (() => {
              if (
                !managerTeamList?.length &&
                teamDetailManagerDataResponseStatus === "SUCCESS"
              ) {
                return (
                  <div
                    className="mev-teamContainer"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "350px",
                    }}
                  >
                    <img
                      src={TaskNotFoundImage}
                      alt="No Data Found"
                      style={{ width: "160px", height: "auto" }}
                    />
                    <div
                      style={{
                        color: "#1D2939",
                        fontSize: "16px",
                        fontWeight: "600",
                        fontStyle: "italic",
                        fontFamily: "sans-serif",
                        marginTop: "16px",
                      }}
                    >
                      “there's nothing here”
                    </div>
                  </div>
                );
              }

              const targetDateStr = filters?.end_date
                ? moment(filters.end_date, "DD-MM-YY").format("YYYY-MM-DD")
                : moment().format("YYYY-MM-DD");
              const todayEntry =
                managerTeamList?.find((item) => item.date === targetDateStr) ||
                selectedEmployee;

              return (
                <div className="mev-teamContainer">
                                    <div
                    className="mev-employeeCard"
                    style={{
                      backgroundColor:
                        todayEntry?.status?.att_status === "present"
                          ? "#0A8F35"
                          : "#DE253F",
                      color: "#fff",
                      borderRadius: "20px",
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "12px",
                    }}
                  >
                    <div
                      className="mev-employeeInfo"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <InitialsCircle
                        fullName={
                          selectedEmployee?.full_name ||
                          managerTeamList[0]?.full_name ||
                          "Employee"
                        }
                        size={48}
                      />

                      <div
                        className="flex items-center"
                        style={{ marginLeft: "12px" }}
                      >
                        <div
                          className="mev-name"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          {selectedEmployee?.full_name ||
                            managerTeamList[0]?.full_name ||
                            "Employee"}
                        </div>
                        <div
                          className="mev-id"
                          style={{
                            fontSize: "14px",
                            marginLeft: "10px",
                            fontWeight: "600",
                          }}
                        >
                          ID #
                          {selectedEmployee?.employee_id ||
                            managerTeamList[0]?.employee_id ||
                            "N/A"}
                        </div>
                      </div>
                    </div>

                    <div
                      className="mev-timeBlock"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      {todayEntry?.clock_in ? (
                        <>
                          <span
                            className="mev-timePill"
                            style={{
                              background: "rgba(255,255,255,0.2)",
                              padding: "4px 12px",
                              borderRadius: "8px",
                              fontSize: "13px",
                              fontWeight: "500",
                            }}
                          >
                            <span
                              style={{ fontSize: "12px" }}
                              class="material-symbols-rounded"
                            >
                              login
                            </span>
                            {moment(todayEntry.clock_in, "HH:mm:ss").format(
                              "h:mm A",
                            )}
                          </span>
                          <span
                            className="mev-timePill"
                            style={{
                              background: "rgba(255,255,255,0.2)",
                              padding: "4px 12px",
                              borderRadius: "8px",
                              fontSize: "13px",
                              fontWeight: "500",
                            }}
                          >
                            <span
                              style={{ fontSize: "12px" }}
                              class="material-symbols-rounded"
                            >
                              logout
                            </span>
                            {todayEntry?.clock_out
                              ? moment(todayEntry.clock_out, "HH:mm:ss").format(
                                  "h:mm A",
                                )
                              : "Pending"}
                          </span>
                        </>
                      ) : (
                        <>
                          <span
                            className="mev-timePill"
                            style={{
                              background: "rgba(255,255,255,0.2)",
                              padding: "4px 12px",
                              borderRadius: "8px",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#FFD2D2",
                            }}
                          >
                            <span
                              style={{ fontSize: "12px", color: "#FE9A9A" }}
                              class="material-symbols-rounded"
                            >
                              login
                            </span>{" "}
                            <div className="mev-absent-text">Absent</div>
                          </span>
                          <span
                            className="mev-timePill"
                            style={{
                              background: "rgba(255,255,255,0.2)",
                              padding: "4px 12px",
                              borderRadius: "8px",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#FFD2D2",
                            }}
                          >
                            <span
                              style={{ fontSize: "12px", color: "#FE9A9A" }}
                              class="material-symbols-rounded"
                            >
                              logout
                            </span>{" "}
                            <div className="mev-absent-text">Absent</div>
                          </span>
                        </>
                      )}
                    </div>

                    <div
                      className="mev-presentBadge"
                      style={{
                        background: todayEntry?.status?.weekly_off
                          ? "#f1f6fa"
                          : "rgba(255,255,255,0.2)",
                        color: todayEntry?.status?.weekly_off
                          ? "#9AA8CD"
                          : "#fff",
                        padding: "6px 16px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      {todayEntry?.status?.att_status === "present"
                        ? "PRESENT TODAY"
                        : "ABSENT TODAY"}
                    </div>
                  </div>

                                    <div className="mev-time">
                    {(() => {

                      const dataMap = {};
                      managerTeamList?.forEach((item) => {
                        dataMap[item.date] = item;
                      });

                      const startDate = filters?.start_date
                        ? moment(filters.start_date, "DD-MM-YY")
                        : moment().subtract(1, "month");
                      const endDate = filters?.end_date
                        ? moment(filters.end_date, "DD-MM-YY")
                        : moment();

                      const allDates = [];
                      let cur = startDate.clone();
                      while (cur.isSameOrBefore(endDate, "day")) {
                        allDates.push(cur.format("YYYY-MM-DD"));
                        cur.add(1, "day");
                      }

                      const isSameMonth = startDate.isSame(endDate, "month");
                      const isSameYear = startDate.isSame(endDate, "year");

                      let headLabel = "";
                      if (isSameMonth && isSameYear) {
                        headLabel = startDate.format("MMMM YYYY") + " timeline";
                      } else if (isSameYear) {
                        headLabel = `${startDate.format("MMM")} - ${endDate.format("MMM YYYY")} timeline`;
                      } else {
                        headLabel = `${startDate.format("MMM 'YY")} - ${endDate.format("MMM 'YY")} timeline`;
                      }

                      return (
                        <>
                          <div className="mev-timeline-head">{headLabel}</div>
                          <div className="mev-timeline">
                            <div className="mev-timelineScroll">
                              {allDates.map((dateStr) => {
                                const item = dataMap[dateStr];
                                const dayNumStr = moment(dateStr).format("DD");
                                const isToday =
                                  dateStr === moment().format("YYYY-MM-DD");

                                if (!item) {

                                  return (
                                    <div
                                      key={dateStr}
                                      className={`mev-dayBox ${isToday ? "mev-selected" : ""}`}
                                    />
                                  );
                                }

                                const st = item.status;
                                let color = "gray";
                                if (st?.holiday) color = "purple";
                                else if (st?.leave_type) color = "black";
                                else if (st?.compoff === "add") color = "blue";
                                else if (st?.compoff === "paid") color = "blue";
                                else if (st?.compoff === "sub")
                                  color = "orange";
                                else if (st?.weekly_off) color = "gray";
                                else if (st?.att_status === "present")
                                  color = "green";
                                else if (st?.att_status === "absent")
                                  color = "red";

                                return (
                                  <div
                                    key={dateStr}
                                    className={`mev-dayBox ${isToday ? "mev-selected" : ""}`}
                                  >
                                    <span
                                      className={`mev-dayNumber mev-${color}`}
                                    >
                                      {dayNumStr}
                                    </span>
                                    <span
                                      className={`mev-dot dot mev-${color}`}
                                    ></span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      );
                    })()}
                  </div>

                  <div className="mev-attendanceList">
                    {managerTeamList?.map((item, index) => {
                      const dateObj = moment(item.date);
                      const dayName = dateObj.format("ddd");
                      const formattedDate = dateObj.format("D MMM'YY");
                      const isLastElement =
                        managerTeamList.length === index + 1;

                      return (
                        <div
                          className={`mev-row ${mevExpandedRows.has(index) ? "mev-row--expanded" : ""}`}
                          key={index}
                          ref={isLastElement ? lastTeamElementRef : null}
                          onClick={() => {
                            if (window.innerWidth <= 640) {
                              setMevExpandedRows((prev) => {
                                const next = new Set(prev);
                                if (next.has(index)) next.delete(index);
                                else next.add(index);
                                return next;
                              });
                            }
                          }}
                        >
                          <div className="mev-row-top-wrap">
                            <div className="mev-left">
                              <div
                                className={`mev-date ${item.status?.weekly_off && !item.clock_in ? "mev-weekend-border" : ""}`}
                              >
                                {" "}
                                {dayName}{" "}
                              </div>
                              <span
                                className={
                                  item.status?.weekly_off && !item.clock_in
                                    ? "mev-weekend-text"
                                    : ""
                                }
                              >
                                {formattedDate}
                              </span>
                            </div>
                            <span className="mev-mobile-chevron material-symbols-rounded">
                              expand_more
                            </span>
                          </div>
                          <div className="mev-row-bottom-wrap">
                            <div className="mev-times">
                            {item.clock_in ? (
                              <>
                                <div className="mn-time-wrap">
                                  <div
                                    className="mn-time-icon mn-icon-enter"
                                    style={{
                                      "--icon-url": `url(${StatusEnterIcon})`,
                                    }}
                                  />
                                  <div>
                                    {moment(item.clock_in, "HH:mm:ss").format(
                                      "h:mm A",
                                    )}
                                  </div>
                                </div>
                                <div
                                  className={`mn-time-wrap ${!item.clock_out ? "mn-time-wrap-null" : ""}`}
                                >
                                  <div
                                    className="mn-time-icon mn-icon-exit"
                                    style={{
                                      "--icon-url": `url(${StatusExitIcon})`,
                                    }}
                                  />
                                  <div>
                                    {item.clock_out
                                      ? moment(
                                          item.clock_out,
                                          "HH:mm:ss",
                                        ).format("h:mm A")
                                      : "Pending"}
                                  </div>
                                </div>
                              </>
                            ) : item.status?.weekly_off ||
                              item.status?.holiday ? null : (
                              <>
                                <div className="mn-time-wrap mn-time-wrap-null">
                                  <div
                                    className="mn-time-icon mn-icon-enter"
                                    style={{
                                      "--icon-url": `url(${StatusEnterIcon})`,
                                    }}
                                  />
                                  <div>{formatTime(null, item.status)}</div>
                                </div>
                                <div className="mn-time-wrap mn-time-wrap-null">
                                  <div
                                    className="mn-time-icon mn-icon-exit"
                                    style={{
                                      "--icon-url": `url(${StatusExitIcon})`,
                                    }}
                                  />
                                  <div>{formatTime(null, item.status)}</div>
                                </div>
                              </>
                            )}
                            </div>
                            <div className="mev-right">
                            {(() => {
                              const st = item.status;
                              if (!st) return null;

                              if (st.holiday) {
                                return (
                                  <span className="mev-badge mev-holiday">
                                    {st.holiday.toUpperCase()}
                                  </span>
                                );
                              }

                              if (st.leave_type) {
                                const leaveInfo = leaveTypesMap.find(
                                  (lt) => lt.leave_type === st.leave_type,
                                );
                                const leaveLabel = leaveInfo
                                  ? leaveInfo.description.toUpperCase()
                                  : st.leave_type.toUpperCase();
                                const leaveIcon = getLeaveIcon(st.leave_type);
                                return (
                                  <span
                                    className="mev-badge mev-leave"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                    }}
                                  >
                                    <img
                                      src={leaveIcon}
                                      alt=""
                                      className="mn-badge-icon"
                                    />
                                    {leaveLabel}
                                  </span>
                                );
                              }

                              if (st.compoff === "add") {
                                return (
                                  <div style={{ display: "flex", gap: "8px" }}>
                                    <span className="mev-badge mev-comp">
                                      COMP OFF - {st?.compoff}
                                    </span>
                                    {st.att_status && (
                                      <span
                                        className={`mev-badge mev-${st.att_status === "present" || st.att_status === "logged_out" ? "present" : "absent"}`}
                                      >
                                        {st.att_status === "logged_out"
                                          ? "LOGGED OUT"
                                          : st.att_status
                                              .toUpperCase()
                                              .replace("_", " ")}
                                      </span>
                                    )}
                                  </div>
                                );
                              }

                              if (st.weekly_off) {
                                return (
                                  <span className="mev-badge mev-weekend">
                                    WEEKEND
                                  </span>
                                );
                              }

                              if (
                                st.att_status === "present" ||
                                st.att_status === "logged_out"
                              ) {
                                return (
                                  <span className="mev-badge mev-present">
                                    {st.att_status === "logged_out"
                                      ? "LOGGED OUT"
                                      : "PRESENT"}
                                  </span>
                                );
                              }

                              if (
                                st.att_status === "absent" ||
                                st.att_status === "leave"
                              ) {
                                return (
                                  <span className="mev-badge mev-absent">
                                    {st.att_status
                                      .toUpperCase()
                                      .replace("_", " ")}
                                  </span>
                                );
                              }

                              return null;
                            })()}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()
          ) : (
            <div
              className="mn-team-list"
              style={!managerTeamList?.length ? { overflow: "visible" } : {}}
            >
              {!managerTeamList?.length &&
              teamDetailManagerDataResponseStatus !== "PENDING" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    flex: 1,
                    minHeight: "350px",
                    gap: "16px",
                  }}
                >
                  <img
                    src={TaskNotFoundImage}
                    alt="No Data Found"
                    style={{ width: "160px", height: "auto" }}
                  />
                  <div
                    style={{
                      color: "#1D2939",
                      fontSize: "16px",
                      fontWeight: "600",
                      fontStyle: "italic",
                      fontFamily: "sans-serif",
                    }}
                  >
                    “there's nothing here”
                  </div>
                </div>
              ) : (
                managerTeamList?.map((member, index) => {
                  const isLastElement = managerTeamList.length === index + 1;
                  return (
                    <div
                      className={`mn-team-row ${expandedRows.has(index) ? "mn-expanded" : ""}`}
                      key={index}
                      ref={isLastElement ? lastTeamElementRef : null}
                      onClick={() => {
                        if (window.innerWidth <= 640) {
                          setExpandedRows((prev) => {
                            const next = new Set(prev);
                            if (next.has(index)) next.delete(index);
                            else next.add(index);
                            return next;
                          });
                          return;
                        }
                        employeeViewRequestedRef.current = true;
                        setSelectedEmployee(member);
                        setSearch(member?.full_name || "");
                        if (setFilters)
                          setFilters((prev) => ({
                            ...prev,
                            search_term: member?.employee_id || "",
                          }));
                      }}
                    >
                      <div className="mn-row-top-wrap">
                        <div className="mn-left">
                          <div className="mn-profile-pic">
                            <InitialsCircle
                              fullName={member?.full_name}
                              size={40}
                              borderRadius={"8px"}
                            />
                          </div>
                          <div className="mn-profile-name">
                            {member?.full_name}
                            <span>ID #{member?.employee_id}</span>
                          </div>
                        </div>
                        <div className="mn-date-info">
                          <div className="mn-weekday-pill">
                            {member?.date
                              ? moment(member.date).format("ddd")
                              : moment().format("ddd")}
                          </div>
                          <div className="mn-date-text">
                            {member?.date
                              ? moment(member.date).format("D MMM'YY")
                              : moment().format("D MMM'YY")}
                          </div>
                        </div>
                        <span className="mn-mobile-chevron material-symbols-rounded">
                          expand_more
                        </span>
                      </div>
                      <div className="mn-row-bottom-wrap">
                        <div className="mn-middle">
                          {!member?.status?.holiday && (
                            <>
                              <div
                                className={`mn-time-wrap ${!member?.clock_in ? "mn-time-wrap-null" : ""}`}
                              >
                                <div
                                  className="mn-time-icon mn-icon-enter"
                                  style={{
                                    "--icon-url": `url(${StatusEnterIcon})`,
                                  }}
                                />
                                <div>
                                  {formatTime(member?.clock_in, member?.status)}
                                </div>
                              </div>
                              <div
                                className={`mn-time-wrap ${!member?.clock_out ? "mn-time-wrap-null" : ""}`}
                              >
                                <div
                                  className="mn-time-icon mn-icon-exit"
                                  style={{
                                    "--icon-url": `url(${StatusExitIcon})`,
                                  }}
                                />
                                <div>
                                  {formatTime(member?.clock_out, member?.status)}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="mn-right">{renderStatus(member)}</div>
                        <button
                          className="mn-mobile-view-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            employeeViewRequestedRef.current = true;
                            setSelectedEmployee(member);
                            setSearch(member?.full_name || "");
                            if (setFilters)
                              setFilters((prev) => ({
                                ...prev,
                                search_term: member?.employee_id || "",
                              }));
                          }}
                        >
                          view
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
                          </div>
          )}
        </>
      )}
    </div>
  );
};

export default ManagerTeamView;
